import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, HostBinding, Input, ViewChild, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from 'se-fe-form-service';
import { SeFeFormControlDirective, SE_FE_FORM_FIELD_INPUT } from 'se-fe-form-service';

class SeFeFormFieldTextStylesComponent {
}
SeFeFormFieldTextStylesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextStylesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldTextStylesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldTextStylesComponent, selector: "[seFeFormFieldTextStyles]", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".se-fe-form-field-text__label-content>*:not(.se-fe-form-field-text__input):not(se-fe-chip):not(se-fe-removable-chip):not(se-fe-icon):not(se-fe-button){margin-left:calc(var(--se-content-spacing) / 2)!important;margin-right:calc(var(--se-content-spacing) / 2)!important}.se-fe-form-field-text__label-content>se-fe-button{margin:0 0-var(--se-content-spacing)!important}.se-fe-form-field-text--legacy[class] .se-fe-form-field-text__label-content>se-fe-button>button{min-height:22px}.se-fe-form-field-text__label-content>se-fe-chip,.se-fe-form-field-text__label-content>se-fe-removable-chip{margin:2px!important}.se-fe-form-field-text__label-content>se-fe-icon{margin:0 calc(var(--se-content-spacing) / 2)!important}.se-fe-form-field-text__label-content>se-fe-icon:first-child{margin-right:0!important}.se-fe-form-field-text__label-content>se-fe-icon:last-child{margin-left:0!important}.se-fe-form-field-text>*{flex:0 0 auto}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextStylesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[seFeFormFieldTextStyles]',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-form-field-text-styles.component.scss'],
                    encapsulation: ViewEncapsulation.None
                }]
        }] });

class SeFeFormFieldTextComponent extends SeFeFormControlDirective {
    constructor(injector, seFeFormService) {
        super(injector, seFeFormService);
        this.injector = injector;
        this.seFeFormService = seFeFormService;
        this.labelFor = `se-fe-label-${SeFeFormFieldTextComponent.timeStamp}-${SeFeFormFieldTextComponent.labelCounter++}`;
        this.baseClasses = 'se-fe-form-field-text se-fe-theme--form-field';
        this.seFeDataWrap = false;
        this.seFeDataComfy = true;
        this.seFeDataType = 'text';
        this.seFeDataReadOnly = false;
    }
    get readOnlyClass() { return !!this.isReadOnly; }
    get errorClass() { return !!this.errors.length; }
    get legacyClass() { return !this.seFeDataComfy; }
    get disabled() { var _a; return ((_a = this.control) === null || _a === void 0 ? void 0 : _a.disabled) ? true : null; }
    ngAfterViewInit() {
        this.updateInputSize();
        this.listenForDisable();
    }
    inputChange($event) {
        super.inputChange($event);
        this.updateInputSize();
    }
    textInputFocus() {
        var _a, _b;
        (_b = (_a = this.input) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
    }
    toggleFocus(evt) {
        if (evt.type === 'blur') {
            this.touched(evt);
        }
    }
    get isReadOnly() {
        return this.seFeDataReadOnly ? true : undefined;
    }
    listenForDisable() {
        this.setDisabledStatus(this.control.status);
        this.control.statusChanges.subscribe(status => this.setDisabledStatus(status));
    }
    setDisabledStatus(status) {
        var _a;
        const elem = (_a = this.input) === null || _a === void 0 ? void 0 : _a.nativeElement;
        if (!elem)
            return;
        elem.disabled = status === 'DISABLED';
    }
    updateInputSize() {
        const el = this.input.nativeElement;
        el.style.width = '';
        const boxWidth = el.offsetWidth + 1; // account for rounding errors
        const textWidth = el.scrollWidth;
        if (textWidth > boxWidth)
            el.style.width = `${textWidth}px`;
    }
}
SeFeFormFieldTextComponent.timeStamp = Date.now();
SeFeFormFieldTextComponent.labelCounter = 1;
SeFeFormFieldTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextComponent, deps: [{ token: i0.Injector }, { token: i1.SeFeFormService }], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldTextComponent, selector: "se-fe-form-field-text", inputs: { seFeDataWrap: "seFeDataWrap", seFeDataComfy: "seFeDataComfy", seFeDataType: "seFeDataType", seFeDataRows: "seFeDataRows", seFeDataReadOnly: "seFeDataReadOnly", seFeDataAria: "seFeDataAria", seFeDataAutoComplete: "seFeDataAutoComplete", seFeDataInputMode: "seFeDataInputMode", seFeDataPlaceholder: "seFeDataPlaceholder" }, host: { properties: { "class": "this.baseClasses", "class.se-fe-form-field-text--read-only": "this.readOnlyClass", "class.se-fe-form-field-text--errors": "this.errorClass", "class.se-fe-form-field-text--legacy": "this.legacyClass", "attr.inert": "this.disabled", "class.se-fe-form-field-text--wrap": "this.seFeDataWrap" } }, providers: [
        {
            provide: SE_FE_FORM_FIELD_INPUT,
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            useExisting: SeFeFormFieldTextComponent,
        },
    ], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div (click)=\"textInputFocus()\" seFeFormFieldTextStyles class=\"se-fe-form-field-text__label\">\n  <div class=\"se-fe-form-field-text__label-content\">\n    <ng-content *ngIf=\"!seFeDataRows\" select=\"[seFeFormFieldTextBefore]\"></ng-content>\n    <input\n      #input\n      *ngIf=\"!seFeDataRows\"\n      id=\"{{ labelFor }}\"\n      type=\"{{ seFeDataType }}\"\n      (input)=\"inputChange($event)\"\n      (blur)=\"toggleFocus($event)\"\n      (focus)=\"toggleFocus($event)\"\n      placeholder=\"{{ seFeDataPlaceholder }}\"\n      value=\"{{ control.value }}\"\n      [attr.aria-describedby]=\"helpErrorIds\"\n      [attr.role]=\"seFeDataAria?.role\"\n      [attr.aria-expanded]=\"seFeDataAria?.expanded\"\n      [attr.aria-controls]=\"seFeDataAria?.controls\"\n      class=\"se-fe-form-field-text__input se-fe-theme--form-field-input\"\n      [attr.inputmode]=\"seFeDataInputMode\"\n      [attr.autocomplete]=\"seFeDataAutoComplete\"\n      [attr.readonly]=\"isReadOnly\"\n    />\n    <textarea\n      #input\n      *ngIf=\"seFeDataRows\"\n      [attr.rows]=\"seFeDataRows\"\n      id=\"{{ labelFor }}\"\n      (input)=\"inputChange($event)\"\n      (blur)=\"toggleFocus($event)\"\n      (focus)=\"toggleFocus($event)\"\n      placeholder=\"{{ seFeDataPlaceholder }}\"\n      value=\"{{ control.value }}\"\n      [attr.aria-describedby]=\"helpErrorIds\"\n      class=\"se-fe-form-field-text__input se-fe-theme--form-field-input\"\n      [attr.inputmode]=\"seFeDataInputMode\"\n      [attr.autocomplete]=\"seFeDataAutoComplete\"\n      [attr.readonly]=\"isReadOnly\">\n    </textarea>\n    <span class=\"se-fe-form-field-text__after\">\n      <ng-content *ngIf=\"!seFeDataRows\" select=\"[seFeFormFieldTextAfter]\"></ng-content>\n    </span>\n  </div>\n</div>\n<ng-content select=\"[seFeFormFieldTextAction]\"></ng-content>\n", styles: [":host{background:var(--se-bg);border-radius:4px;border-color:var(--se-border);border-style:solid;border-width:1px;box-sizing:border-box;color:var(--se-text);font:var(--se-body-font);width:100%}:host .se-fe-form-field-text__input{border:0;padding:0;margin:0;font:inherit;background:transparent}:host .se-fe-form-field-text__input:focus{outline:none}:host{display:flex;flex-wrap:wrap;font:var(--se-body-font)}:host.se-fe-form-field-text--errors{--se-focus-inner: var(--se-critical);border-color:var(--se-critical)}:host.se-fe-form-field-text--read-only{--se-bg: form-field-text.$background-read-only}:host .se-fe-form-field-text__label{display:flex;color:var(--se-label);cursor:text;flex:1 1 0;padding:6px calc(var(--se-content-spacing) / 2);overflow:hidden}:host .se-fe-form-field-text__label-content{align-items:center;display:flex;flex:1;flex-wrap:nowrap;width:calc(100% - calc(var(--se-content-spacing) / 2) * 2)}:host .se-fe-form-field-text__input{color:var(--se-text);flex:1 1 auto;line-height:18px;padding:8px calc(var(--se-content-spacing) / 2)!important;width:0;text-overflow:ellipsis}:host .se-fe-form-field-text__after{--se-icon: var(--se-subdued-icon)}:host textarea.se-fe-form-field-text__input{border-radius:0 4px 4px 0;margin-right:calc(0px - calc(var(--se-content-spacing) / 2) * 3)!important;padding-right:calc(calc(var(--se-content-spacing) / 2) + calc(var(--se-content-spacing) / 2))!important}:host.se-fe-form-field-text--legacy .se-fe-form-field-text__label{padding-bottom:0;padding-top:0}:host.se-fe-form-field-text--wrap .se-fe-form-field-text__label-content{flex-wrap:wrap}\n"], components: [{ type: SeFeFormFieldTextStylesComponent, selector: "[seFeFormFieldTextStyles]" }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-form-field-text',
                    templateUrl: './se-fe-form-field-text.component.html',
                    styleUrls: ['./se-fe-form-field-text.component.scss'],
                    providers: [
                        {
                            provide: SE_FE_FORM_FIELD_INPUT,
                            // eslint-disable-next-line @typescript-eslint/no-use-before-define
                            useExisting: SeFeFormFieldTextComponent,
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1.SeFeFormService }]; }, propDecorators: { baseClasses: [{
                type: HostBinding,
                args: ['class']
            }], readOnlyClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--read-only']
            }], errorClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--errors']
            }], legacyClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--legacy']
            }], disabled: [{
                type: HostBinding,
                args: ['attr.inert']
            }], seFeDataWrap: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-text--wrap']
            }, {
                type: Input
            }], seFeDataComfy: [{
                type: Input
            }], seFeDataType: [{
                type: Input
            }], seFeDataRows: [{
                type: Input
            }], seFeDataReadOnly: [{
                type: Input
            }], seFeDataAria: [{
                type: Input
            }], seFeDataAutoComplete: [{
                type: Input
            }], seFeDataInputMode: [{
                type: Input
            }], seFeDataPlaceholder: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class SeFeFormFieldTextModule {
}
SeFeFormFieldTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeFormFieldTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, declarations: [SeFeFormFieldTextComponent,
        SeFeFormFieldTextStylesComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], exports: [SeFeFormFieldTextComponent,
        FormsModule,
        ReactiveFormsModule] });
SeFeFormFieldTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
        ], FormsModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldTextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeFormFieldTextComponent,
                        SeFeFormFieldTextStylesComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        SeFeFormFieldTextComponent,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeFormFieldTextComponent, SeFeFormFieldTextModule };
